import moment from 'moment';

export class Clock {
  static get now(): moment.Moment {
    return moment();
  }
}
